document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.activation-campaign__video-carousel-slide .activation-campaign__video-carousel-video');
    let currentVideo = null;

    let originalSlides = document.querySelectorAll('.activation-campaign__video-carousel .swiper-wrapper .swiper-slide').length;

    let slidesPerView = 3;
    let centeredSlides = true;

    if (originalSlides < 3) {
        slidesPerView = originalSlides;
        centeredSlides = originalSlides === 1 ? false : true;
    }

    let videoCarousel = document.querySelector('.activation-campaign__video-carousel-wrapper');

    if(originalSlides === 1) {
        videoCarousel.classList.add('one-slide-carousel')
    } 

    if (originalSlides === 2) {
        videoCarousel.classList.add('two-slides-carousel')
    }

    let activationCampaignVideoCarousel = new Swiper(".js_activation_campaign_video_carousel", {
        slidesPerView: originalSlides === 1 ? 1 : 2,
        centeredSlides: centeredSlides,
        loop: originalSlides > 1,
        breakpoints: {
            767: {
                slidesPerView: originalSlides === 1 ? originalSlides : 3,
            },
            991: {
                allowTouchMove: false,
                slidesPerView: originalSlides === 1 ? originalSlides : 3,
            }
        },
        on: {
            click: (swiper) => {
                const clickedSlide = swiper.clickedSlide;
                if (!clickedSlide) return;

                if (clickedSlide.classList.contains('locked')) {
                    return; 
                }

                const video = clickedSlide.querySelector('.activation-campaign__video-carousel-video');
                if (!video) return;

                if (currentVideo === video) {
                    if (video.paused) {
                        video.play();
                        clickedSlide.classList.add('video-playing');
                    } else {
                        video.pause();
                        clickedSlide.classList.remove('video-playing');
                    }
                } else {
                    if (currentVideo) {
                        const previousParentSlide = currentVideo.closest('.activation-campaign__video-carousel-slide');
                        if (previousParentSlide) {
                            previousParentSlide.classList.remove('video-playing');
                        }
                        currentVideo.pause();
                    }

                    video.play();
                    clickedSlide.classList.add('video-playing');
                    currentVideo = video;
                }
            },
            slideChange: function () {
                videos.forEach(function (video) {
                    if (!video.paused) {
                        video.currentTime = 0; 
                        video.pause();
                        let parentSlide = video.closest('.activation-campaign__video-carousel-slide');
                        parentSlide.classList.remove('video-playing');
                    }
                });
            }
        },
        navigation: {
            nextEl: ".activation-campaign__video-carousel .swiper-button-next",
            prevEl: ".activation-campaign__video-carousel .swiper-button-prev"
        }
    });

    videos.forEach(video => {
        video.addEventListener('ended', function() {
            const parentSlide = video.closest('.activation-campaign__video-carousel-slide');
            if (parentSlide) {
                parentSlide.classList.remove('video-playing');
            }
            video.currentTime = 0; 
            currentVideo = null;
        });
    });
});